/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path languageswitch
 * @description App bar for the system
 */
import React from "react";
import { useAppContext } from "./../context/AppCtxProvider";
import AppBarContext from "./../appbar/BusinessPortalAppBarContext";
type ElementProps = React.ComponentProps<
  React.HTMLFactory<HTMLElementTagNameMap["div"]>
>;
const RTLProvider: React.FunctionComponent<ElementProps> = (
  props: ElementProps
) => {
  const { language } = React.useContext(AppBarContext);
  const rtl = useAppContext((s) => s.rtl);
  return <div dir={rtl ? "rtl" : "ltr"}>{props?.children}</div>;
};
export default RTLProvider;
